import React from "react";
import { classNames } from "../../helpers";
import { useSelector } from "react-redux";
import { loadingState } from "../../redux/reducers/loadingReducer";
import { ChevronDownIcon, ExclamationCircleIcon } from '@heroicons/react/16/solid'

export default function TwSelectGroup(props) {
  const loadingReduxState = useSelector(loadingState);
  const { children, name = "", label = "", className = "", errors = {}, error = "", leftIcon = "", rightIcon = "", options = [] } = props
  let inputProps = { ...props }
  delete inputProps.leftIcon
  delete inputProps.rightIcon
  delete inputProps.errors
  delete inputProps.defaultValue
  delete inputProps.options
  delete inputProps.selectClass
  let inputLableClass = "text-black/[0.6]"
  let inputClass = "text-gray-900 outline-gray-300 placeholder:text-gray-400 hover:outline-indigo-bz focus-within:outline-indigo-bz"
  if (name && errors[name] && errors[name] !== "") {
    props = {
      ...props,
      error: props.errors[name]
    };
  }
  if (props.error && props.error !== "") {
    inputLableClass = "text-red-600"
    inputClass = "text-red-900 outline-red-300 placeholder:text-red-300 focus-within:outline-red-600"
  }

  return (
    <div className="w-full sm:w-full sm:max-w-sm md:max-w-lg">
      {label && (<label htmlFor={name} className={classNames("block text-sm/6 font-medium", inputLableClass)}>
        {label}
      </label>)}
      <div className={label && "mt-2"}>
        <div className={classNames("flex items-center rounded-2xl [bg-input-bz] bg-white px-4 md:px-5 outline outline-1 -outline-offset-1 outline-gray-300 hover-within:outline hover-within:outline-2 hover-within:-outline-offset-2 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 ",
          inputClass,
          props?.className || "")}>
          {leftIcon && (
            <div className="shrink-0 select-none text-base text-gray-500 sm:text-sm/6">{leftIcon}</div>
          )}
          <div className="grid grid-cols-1 w-full">
            <select
              {...inputProps}
              className={classNames("bg-transparent py-3 px-3 md:py-5 md:px-5 text-base placeholder:text-gray-400 col-start-1 row-start-1 w-full appearance-none rounded-md sm:text-sm/6 focus:outline focus:outline-0",
                inputProps.value && inputProps.value !== "" ? "text-gray-900" : "text-gray-400",
                props?.selectClass || ""
              )}
            >
              {options.map((d, i) => (<option key={i} value={d.value} onClick={d?.onClick ? d?.onClick : () => { }} className={`text-gray-900`}>{d.title}</option>))}
            </select>
            <ChevronDownIcon
              aria-hidden="true"
              className="pointer-events-none col-start-1 row-start-1 [mr-2] size-5 self-center justify-self-end text-gray-500 sm:size-4"
            />
          </div>
          {props.error && (<ExclamationCircleIcon
            aria-hidden="true"
            className="pointer-events-none col-start-1 row-start-1 size-5 self-center justify-self-end text-red-500 sm:size-4"
          />)}
        </div>
      </div>
      {props.error && (<p id="email-error" className="mt-2 text-sm text-red-600">
        {props.error}
      </p>)}
    </div>
  );
}
